import { failSilently } from '../../utils/failSilently';
import { sendGA4Event } from '../shared/sendGa4Event';
import type { SustainabilityViewEvent } from './ga4Sustainability';

const view = () => {
    const event: SustainabilityViewEvent = {
        event: 'sustainability',
        type: 'view',
        event_key: 'hd_product_details',
    };

    sendGA4Event(event);
};

export default {
    view: failSilently(view),
};
